(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    (function () {
  var _scrollY = 0;

  function lockScroll() {
    _scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
  }

  function openSlidein(panel, trigger) {
    // Move to a direct child of <body> so the fixed overlay/panel always
    // paints above the header, even if an ancestor section (e.g. one with
    // a scroll-reveal transform) traps it in a lower stacking context.
    if (panel.parentElement !== document.body) {
      document.body.appendChild(panel);
    }
    panel.hidden = false;
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
    });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    lockScroll();
    var focusEl = panel.querySelector('.text-slidein__panel');
    if (focusEl) focusEl.focus();
  }

  function closeSlidein(el) {
    el.classList.remove('is-open');
    unlockScroll();
    var id = el.id;
    var trigger = document.querySelector('[data-slidein-id="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    el.addEventListener('transitionend', function hide() {
      el.hidden = true;
      el.removeEventListener('transitionend', hide);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-slidein-id]');
    if (trigger) {
      var id = trigger.dataset.slideinId;
      var panel = document.getElementById(id);
      if (!panel) return;
      openSlidein(panel, trigger);
      return;
    }
    var closer = e.target.closest('.text-slidein__close, .text-slidein__overlay');
    if (closer) {
      var slidein = closer.closest('.text-slidein');
      if (!slidein) return;
      closeSlidein(slidein);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.text-slidein.is-open');
      if (open) closeSlidein(open);
      return;
    }
    if (e.key === 'Enter' || e.key === ' ') {
      var trigger = e.target.closest('[data-slidein-id]');
      if (!trigger) return;
      e.preventDefault();
      var id = trigger.dataset.slideinId;
      var panel = document.getElementById(id);
      if (!panel) return;
      openSlidein(panel, trigger);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
